import { createSlice } from "@reduxjs/toolkit";
import { Assets } from "../../../../assets";
import { baseJson, menuSelect, menuSeparateMenus } from "../../../../types/initStore/initUi";

const initialState = {
	menuSelect: menuSelect.principal,
	cardMenuSelect: menuSeparateMenus,
	selectCardMenu: baseJson,
	nameHeaderCardContainer: "",
	iconHeaderContainer: Assets.icon.city,
	selectLocationId: 1000,
	activeModal: false,
	finishLoader360: false,
	modalImageView: "",
	activeModalImageView: false,
	loading: false,
};

export const isUiSlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		toggleLoading: (state, { payload }) => {
			state.loading = payload;
		},
		toggleActiveModal: (state, { payload }) => {
			state.activeModal = payload;
		},
		toggleMenuSelect: (state, { payload }) => {
			state.menuSelect = payload;
		},
		toggleFinishLoader360: (state, { payload }) => {
			state.finishLoader360 = payload;
		},
		setCardMenuSelect: (state, { payload }) => {
			state.cardMenuSelect = payload;
		},
		setNameHeaderCardContainer: (state, { payload }) => {
			state.nameHeaderCardContainer = payload;
		},
		setIconHeaderContainer: (state, { payload }) => {
			state.iconHeaderContainer = payload;
		},
		setSelectLocationId: (state, { payload }) => {
			state.selectLocationId = payload;
		},
		setSelectCardMenu: (state, { payload }) => {
			state.selectCardMenu = payload;
		},
		setModalImageView: (state, { payload }) => {
			state.modalImageView = payload;
		},
		toggleActiveModalImageView: (state, { payload }) => {
			state.activeModalImageView = payload;
		},
	},
});

export const {
	toggleMenuSelect,
	setCardMenuSelect,
	setNameHeaderCardContainer,
	setSelectLocationId,
	toggleFinishLoader360,
	toggleActiveModal,
	setSelectCardMenu,
	setIconHeaderContainer,
	setModalImageView,
	toggleActiveModalImageView,
	toggleLoading,
} = isUiSlice.actions;
